import { db } from "../../db";

export const getLabel = (id) => {
  const label = db.get("labelsAll", id);
  return label?.parent;
};
